import { render } from "./NewPet.vue?vue&type=template&id=36c0494a&scoped=true"
import script from "./NewPet.vue?vue&type=script&lang=js"
export * from "./NewPet.vue?vue&type=script&lang=js"

import "./NewPet.vue?vue&type=style&index=0&id=36c0494a&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c0494a"]])

export default __exports__